import { Skeleton } from '@/components/Skeleton'

export const AppLoadingState = () => {
    return (
        <div className="bg-account-page text-account-strong min-h-screen font-sans">
            <div className="mx-auto flex max-w-5xl flex-col gap-8 px-4 py-8 md:flex-row md:py-12">
                <aside className="flex w-full flex-shrink-0 flex-col gap-6 md:w-64">
                    <div className="flex items-center gap-4 px-2">
                        <Skeleton className="h-12 w-12 rounded-full" />
                        <div className="min-w-0 flex-1 space-y-2">
                            <Skeleton className="h-5 w-28" />
                            <Skeleton className="h-3 w-40 max-w-full" />
                        </div>
                    </div>

                    <div className="border-account-divider bg-account-surface rounded-lg border px-3 py-2.5 shadow-sm">
                        <div className="flex items-center gap-3">
                            <Skeleton className="h-5 w-5 rounded" />
                            <Skeleton className="h-5 w-20" />
                        </div>
                    </div>
                </aside>

                <main className="flex flex-1 flex-col gap-6">
                    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                        <div className="space-y-2">
                            <Skeleton className="h-9 w-36" />
                            <Skeleton className="h-4 w-80 max-w-full" />
                        </div>

                        <Skeleton className="h-10 w-24 self-start" />
                    </div>
                </main>
            </div>
        </div>
    )
}
